export default {
    global: {

    },
    prod: {
        url: "https://evenement.ynov-bordeaux.com",
        suffix: {
            csv: "services/csv",
            api: "services/api",
            image: "services"
        }
    },
    dev: {
        //url: "http://evenement-new.ynov-bordeaux.com",
        url: "http://localhost:5000",
        suffix: {
            api: "api",
            image: "",
            csv: "csv"
        }
    }
}



// WEBPACK FOOTER //
// ./src/config/api.js